import './PricingPage.scss'

import Layout from '@componentsfld/core/Layout'
import { HeadProps } from 'gatsby'
import React, { FunctionComponent } from 'react'
import { IPageContext } from 'Root/Shared/utils/data/buildTypedPage'
import { PuxVWO } from 'Root/Shared/utils/PuxVWO'
import WidgetBuilder from 'Shared/components/builders/WidgetBuilder'
import EasySoftwareEditorContainer from 'Shared/components/EasySoftwareEditorContainer/EasySoftwareEditorContainer'
import PuxAnchor from 'Shared/components/PuxAnchor/PuxAnchor'
import {
  GenericPageProps,
  IEasySoftwarePricingPage,
} from 'Shared/queries/page-queries'
import { PuxAnchorLink } from 'Shared/utils/PuxAnchorLink/PuxAnchorLink'
import PuxMetaTagsGatsby from 'Shared/utils/PuxMetaTagsGatsby'
import { t } from 'ttag'

import AllFeaturesTable from './AllFeaturesTable'
import PlansTable from './PlansTable'

const PricingPage: FunctionComponent<
  GenericPageProps<IEasySoftwarePricingPage>
> = (props) => {
  const pageData = props.pageContext.pageData
  const headerData = props.pageContext.headerData
  const footerData = props.pageContext.footerData
  const currencies =
    pageData.pricingPageCurrencies &&
    pageData.pricingPageCurrencies.contentItems &&
    pageData.pricingPageCurrencies.contentItems.length &&
    pageData.pricingPageCurrencies.contentItems
  const features =
    pageData.pricingPageFeatures &&
    pageData.pricingPageFeatures.contentItems &&
    pageData.pricingPageFeatures.contentItems.length &&
    pageData.pricingPageFeatures.contentItems
  const allFeatures =
    pageData.pricingPageAllFeatures &&
    pageData.pricingPageAllFeatures.contentItems &&
    pageData.pricingPageAllFeatures.contentItems.length &&
    pageData.pricingPageAllFeatures.contentItems

  const links =
    pageData.pricingPageLinks &&
    pageData.pricingPageLinks.contentItems &&
    pageData.pricingPageLinks.contentItems.length &&
    pageData.pricingPageLinks.contentItems

  const midWidgets = props.pageContext.widgets?.midWidgetZone
  const bottomWidgets = props.pageContext.widgets?.bottomWidgetZone

  return (
    <Layout
      localizedPath={pageData.localization?.localizations}
      footerData={footerData}
      headerData={headerData}
      pageContentItemId={pageData.contentItemId}
      pageProperties={props.pageContext.pageProperties}
      resStrings={props.pageContext.resStrings}
    >
      <div className='PricingPage'>
        <div className='PricingPage-table'>
          <div className='Container'>
            <h1 className='PricingPage-title'>{pageData.displayText}</h1>
            <div className='PricingPage-perex perex'>
              <EasySoftwareEditorContainer
                pageContentItemId={pageData.contentItemId}
                wysiwygId={pageData.contentItemId + `-perex`}
                content={pageData.pricingPagePerex}
                editorPath={`easySoftwarePricingPage,pricingPagePerex,html`}
              />
            </div>
            <PlansTable
              currencies={currencies}
              features={features}
              enterpriseContent={pageData.pricingPageEnterpriseContent}
              buyLink={pageData.pricingPageBuyLink}
              editorPath={`easySoftwarePricingPage,pricingPageEnterpriseContent,html`}
              pageContentItemId={pageData.contentItemId}
              wysiwygId={pageData.contentItemId + `-content`}
            />
            <div className='PricingPage-comparison'>
              {links?.length > 0 ? (
                links.map((link) => (
                  <PuxAnchorLink
                    to={link.pricingLinkAnchor}
                    className='Button Button--ghost Button--md Button--scrollDown'
                    iconSize={12}
                    iconName="arrows/down-arrow"
                  >
                    <span>{link.displayText}</span>
                  </PuxAnchorLink>
                ))
              ) : (
                <PuxAnchorLink
                  to='#comparison'
                  className='Button Button--ghost Button--md Button--scrollDown'
                >
                  <span>{t`Redmine.Pricing.ComparisonDetail`}</span>
                </PuxAnchorLink>
              )}
            </div>
          </div>
        </div>

        <div className='Container'>
          <div className='PricingPage-mid-widgets'>
            <WidgetBuilder
              widgetBuilderData={midWidgets}
              pageContentItemId={pageData.contentItemId}
              editorPath={`midWidgetZone,widgets`}
            />
          </div>

          <PuxAnchor id='comparison'>
            <div className='widget-section section-grey'>
              <div className='PricingPage-features pux-container'>
                <h2 className='PricingPage-features-title'>
                  {t`Redmine.Pricing.CompleteFeatures`}
                </h2>
                <AllFeaturesTable
                  allFeatures={allFeatures}
                  currencies={currencies}
                />
              </div>
            </div>
          </PuxAnchor>

          <div className='PricingPage-bottom-widgets'>
            <WidgetBuilder
              widgetBuilderData={bottomWidgets}
              pageContentItemId={pageData.contentItemId}
              editorPath={``}
            />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default PricingPage

export function Head(
  props: HeadProps<never, IPageContext<IEasySoftwarePricingPage>>
): React.ReactElement {
  const pageData = props.pageContext.pageData
  const metaTags = props.pageContext.metaTags

  return (
    <>
      <PuxMetaTagsGatsby
        {...metaTags}
        localizedPaths={pageData.localization?.localizations}
      />
      <PuxVWO
        isEnabled={props.pageContext.pageProperties?.pagePropertiesVWOEnabled}
      />
    </>
  )
}
